import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import BrokerCards from './BrokerCards'
import BrokerComparisonTable from './BrokerComparisonTable'
import HowTo from './HowTo'
import { history } from "../../../store"
import { COMPONENT_IDS } from '../common/common'

import { logPageView } from '../../../utils/emfLogs'
import { Pages } from '../../../utils/loggerConstants'
import { pageLoadLogs } from '../../../utils/loggerUtils'

import { Col, Hr, Container } from '@amzn/stencil-react-components/layout'

export class Broker extends Component {

  componentDidMount(){
    console.log("Mounted Broker");
    logPageView(Pages.Broker);
    pageLoadLogs(navigator.userAgent, Pages.Broker);

    if (history.location.state?.buttonNav) {
      document.getElementById(COMPONENT_IDS.FirstBrokerCard)?.focus();
    }
  }

  render() {
    const{ t } = this.props;

    return (
      <Container>
        <Col gridGap="S500">
          <BrokerCards/>
          <HowTo/>
          <BrokerComparisonTable/>
        </Col>
      </Container>
    );
  }
}

export default connect()(withTranslation('translationsV2')(Broker));
